module.exports = __webpack_public_path__ + "static/aw-6a79ab852c4c181b69ca537d9683a00b.png";